import React from "react";

import { useSelector } from "react-redux";

// Hooks

import CheckProvidersSuppliersOnList from "../../../../../hooks/CheckProvidersSuppliersOnList";

// Components

import FormInputGroup from "../../../../UI/FormInputGroup/FormInputGroup";
import TextInput from "../../../../UI/FormInput/TextInput";
import DropDownInput from "../../../../UI/FormInput/DropDownInput";
import MaskInput from "../../../../UI/FormInput/MaskInput";
import CurrencyInput from "../../../../UI/FormInput/CurrencyInput";
import CalendarInput from "../../../../UI/FormInput/CalendarInput";
import SectionHeading from "../../../../UI/SectionHeading/SectionHeading";
import ButtonWithIcon from "../../../../UI/ButtonWithIcon/ButtonWithIcon";
import JobClientAddressFields from '../JobClientAddressFields';
import JobProviderAddressFields from "../JobProviderAddressFields";

// Utilities

import { formatDropDownOptions, addItemToArray, removeItemFromArray } from "../../../../../utilities/helper-functions";

// Constants

import { MAX_CURRENCY_INPUT_DIGITS, FULL_PHONE_MASK_FORMAT, INTERNATIONAL_FULL_PHONE_MASK_FORMAT, RIF_MASK_FORMAT, PASSPORT_MASK_FORMAT } from "../../../../../config/constants";

import { initialValues } from '../InitialValues';
import Alert from "../../../../UI/Alert/Alert";
import Button from "../../../../UI/Button/Button";

export default function Business({formik}) {
  const dropDownOptions = useSelector((state) => state.options.dropDownOptions);
  return (
    <>
      <FormInputGroup>

        <CalendarInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.fechaConstitutiva`}
          label={'Fecha de constitución del negocio propio'}
          maxDate={new Date()}
          isRequired={true}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.rifType`}
          label={"Tipo RIF"}
          options={formatDropDownOptions(dropDownOptions?.data?.jobIdentificationTypes)}
          isRequired={true}
        />

        <MaskInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.rif`}
          label={"RIF"}
          mask={formik.values.jobReferences?.negocioPropio?.rifType === 'P' ? PASSPORT_MASK_FORMAT : RIF_MASK_FORMAT}
          isRequired={true}
        />

        <TextInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.nombreNegocio`}
          label={'Nombre de la empresa'}
          maxLength={64}
          isRequired={true}
        />

        <TextInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.datosRegistro`}
          label={'Nombre del registro'}
          maxLength={64}
          isRequired={true}
        />

        <MaskInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.numeroNegocio`}
          label={'Número de registro'}
          mask={'*****'}
          isRequired={true}
        />

        <MaskInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.libro`}
          label={'Número de libro'}
          mask={'***************'}
          isRequired={true}
        />
        
        <MaskInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.folio`}
          label={'Folio'}
          mask={'***************'}
          isRequired={true}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.moneda`}
          label={"Moneda"}
          options={formatDropDownOptions(dropDownOptions?.data?.currencies)}
          isRequired={true}
        />

        <CurrencyInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.ingresos`}
          label={'Ingresos Mensuales'}
          isRequired={true}
          max={MAX_CURRENCY_INPUT_DIGITS}
        />
        
        <TextInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.ramo`}
          label={"Ramo del negocio"}
          maxLength={64}
          isRequired={true}
        />

        <TextInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.email`}
          label={"Dirección Email"}
          maxLength={80}
        />

      </FormInputGroup>

      {/* Business Supliers */}

      <>
        <SectionHeading text={'Principales proveedores'} isSubHeading />

        {formik.values?.jobReferences?.negocioPropio?.businessSuppliers?.map((reference, i) => (
          <BussinessSupplierEntry
            i={i}
            key={i}
            index={i}
            formik={formik}
            dropDownOptions={dropDownOptions}
          />
        ))}

        <div className='multiple-input-actions'>

            <ButtonWithIcon
                action={() => addItemToArray(formik, `jobReferences.negocioPropio.businessSuppliers`, initialValues.jobReferences?.negocioPropio?.businessSuppliers[0])}
                label={'Añadir Proveedor'}
                disabled={formik.values?.jobReferences?.negocioPropio?.businessSuppliers?.length === 3}
            />

            <ButtonWithIcon
                action={() => removeItemFromArray(formik, `jobReferences.negocioPropio.businessSuppliers`)}
                icon={'delete'}
                disabled={formik.values?.jobReferences?.negocioPropio?.businessSuppliers?.length === 1}
            />

        </div>

      </>


      {/* Business Clients */}

      <>
        <SectionHeading text={'Clientes'} isSubHeading />

        {formik?.values?.jobReferences?.negocioPropio?.businessClients?.map((reference, i) => (
          <BussinessClientEntry
            i={i}
            key={i}
            index={i}
            formik={formik}
            dropDownOptions={dropDownOptions}
          />
        ))}

        <div className='multiple-input-actions'>

            <ButtonWithIcon
                action={() => addItemToArray(formik, `jobReferences.negocioPropio.businessClients`, initialValues?.jobReferences?.negocioPropio?.businessClients[0])}
                label={'Añadir Cliente'}
                disabled={formik.values?.jobReferences?.negocioPropio?.businessClients?.length === 3}
            />

            <ButtonWithIcon
                action={() => removeItemFromArray(formik, `jobReferences.negocioPropio.businessClients`)}
                icon={'delete'}
                disabled={formik.values?.jobReferences?.negocioPropio?.businessClients?.length === 1}
            />

        </div>

      </>
    </>
  );
}


// Bussiness Supplier Entry

const BussinessSupplierEntry = ({index, formik, dropDownOptions}) => {
  const {
    checkProvidersSuppliersOnListIsLoading,
    checkProvidersSuppliersOnListError,
    handleCheckProvidersSuppliersOnLists,
  } = CheckProvidersSuppliersOnList();

  // Set if the provider or supplier is on a list

  const handleSetisOnList = (isOnList) => {
    formik.setFieldValue(`jobReferences.negocioPropio.businessSuppliers.${index}.isOnList`, isOnList);
    formik.setFieldValue(`jobReferences.negocioPropio.businessSuppliers.${index}.searchedOnList`, true);
  }

  // Check the provider or supplier on the list

  const handleCheckProviderSupplierOnList = () => {
    const name = formik?.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.nombreCompleto;

    handleCheckProvidersSuppliersOnLists(name, handleSetisOnList);
  }
  
  return (
    <div key={index}>

      <h3 className="multiple-input-heading multiple-input-heading-small">Proveedor {index + 1} </h3>

      {checkProvidersSuppliersOnListError &&
      <p className="form-error-message">Ocurrió un error al validar la información. Por favor reintente.</p>}

      {formik.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.searchedOnList && formik.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.isOnList &&
      <p className="form-error-message">Le invitamos a ingresar otro proveedor.</p>}

      <FormInputGroup>

          <TextInput
              formik={formik}
              fieldName={`jobReferences.negocioPropio.businessSuppliers.${index}.nombreCompleto`}
              label={'Nombre'}
              maxLength={64}
              isRequired={true}
              disabled={checkProvidersSuppliersOnListIsLoading}
              additionalFunctions={() => formik.setFieldValue(`jobReferences.negocioPropio.businessSuppliers.${index}.searchedOnList`, false)}
          />

          <JobProviderAddressFields
            formik={formik}
            i={index}
            dropDownOptions={dropDownOptions}
            disabled={checkProvidersSuppliersOnListIsLoading}
          />

          <MaskInput
            formik={formik}
            fieldName={`jobReferences.negocioPropio.businessSuppliers.${index}.telefono`}
            label={"Teléfono"}
            mask={formik?.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.pais === '0' ? FULL_PHONE_MASK_FORMAT : INTERNATIONAL_FULL_PHONE_MASK_FORMAT}
            disabled={!formik?.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.pais || checkProvidersSuppliersOnListIsLoading}
            isRequired={true}
          />

      </FormInputGroup>

      {formik?.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.searchedOnList && !formik?.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.isOnList &&
      <Alert text={'Proveedor validado exitosamente'} />}

      {!formik?.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.searchedOnList &&
      <div>

        <Button
          type="button"
          action={() => handleCheckProviderSupplierOnList()}
          label={'Validar proveedor'}
          additionalStyles={{marginLeft: 0, marginBottom: '2rem', padding: '0.75rem 1.5rem'}}
          isLoading={checkProvidersSuppliersOnListIsLoading}
          disabled={!formik?.values?.jobReferences?.negocioPropio?.businessSuppliers[index]?.nombreCompleto}
        />

        <span>Por favor complete los datos del proveedor para validar.</span>

      </div>}

    </div>
  )
}


// Bussiness Client Entry

const BussinessClientEntry = ({index, formik, dropDownOptions}) => {
  const {
    checkProvidersSuppliersOnListIsLoading,
    checkProvidersSuppliersOnListError,
    handleCheckProvidersSuppliersOnLists,
  } = CheckProvidersSuppliersOnList();

  // Set if the provider or supplier is on a list

  const handleSetisOnList = (isOnList) => {
    formik.setFieldValue(`jobReferences.negocioPropio.businessClients.${index}.isOnList`, isOnList);
    formik.setFieldValue(`jobReferences.negocioPropio.businessClients.${index}.searchedOnList`, true);
  }

  // Check the provider or supplier on the list

  const handleCheckProviderSupplierOnList = () => {
    const name = formik?.values?.jobReferences?.negocioPropio?.businessClients[index]?.nombreCompleto;

    handleCheckProvidersSuppliersOnLists(name, handleSetisOnList);
  }
  
  return (
    <div key={index}>

      <h3 className="multiple-input-heading multiple-input-heading-small">Cliente {index + 1} </h3>

      {checkProvidersSuppliersOnListError &&
      <p className="form-error-message">Ocurrió un error al validar la información. Por favor reintente.</p>}

      {formik.values?.jobReferences?.negocioPropio?.businessClients[index]?.searchedOnList && formik.values?.jobReferences?.negocioPropio?.businessClients[index]?.isOnList &&
      <p className="form-error-message">Le invitamos a ingresar otro cliente.</p>}

      <FormInputGroup>

        <TextInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.businessClients.${index}.nombreCompleto`}
          label={'Nombre'}
          maxLength={64}
          isRequired={true}
          disabled={checkProvidersSuppliersOnListIsLoading}
          additionalFunctions={() => formik.setFieldValue(`jobReferences.negocioPropio.businessClients.${index}.searchedOnList`, false)}
        />

        <JobClientAddressFields
          formik={formik}
          i={index}
          dropDownOptions={dropDownOptions}
          disabled={checkProvidersSuppliersOnListIsLoading}
        />

        <MaskInput
          formik={formik}
          fieldName={`jobReferences.negocioPropio.businessClients.${index}.telefono`}
          label={"Teléfono"}
          mask={formik?.values?.jobReferences?.negocioPropio?.businessClients[index]?.pais === '0' ? FULL_PHONE_MASK_FORMAT : INTERNATIONAL_FULL_PHONE_MASK_FORMAT}
          disabled={!formik?.values?.jobReferences?.negocioPropio?.businessClients[index]?.pais || checkProvidersSuppliersOnListIsLoading}
          isRequired={true}
        />

      </FormInputGroup>

      {formik?.values?.jobReferences?.negocioPropio?.businessClients[index]?.searchedOnList && !formik?.values?.jobReferences?.negocioPropio?.businessClients[index]?.isOnList &&
      <Alert text={'Cliente validado exitosamente'} />}

      {!formik?.values?.jobReferences?.negocioPropio?.businessClients[index]?.searchedOnList &&
      <div>

        <Button
          type="button"
          action={() => handleCheckProviderSupplierOnList()}
          label={'Validar cliente'}
          additionalStyles={{marginLeft: 0, marginBottom: '2rem', padding: '0.75rem 1.5rem'}}
          isLoading={checkProvidersSuppliersOnListIsLoading}
          disabled={!formik?.values?.jobReferences?.negocioPropio?.businessClients[index]?.nombreCompleto}
        />

        <span>Por favor complete los datos del cliente para validar.</span>

      </div>}

    </div>
  )
}